import { connect } from 'react-redux';
import initialBookingStateSelector from '../../selectors/InitialBookingStateSelector';
import InsurancePayForMyselfModal from './InsurancePayForMyselfModal';

const mapStateToProps = (state) => {
    const bookingInitialState = initialBookingStateSelector(state);
    const whiteLabelVanityUrl = bookingInitialState?.vanityUrl;

    return {
        whiteLabelVanityUrl,
    };
};

export default connect(mapStateToProps)(InsurancePayForMyselfModal);
